module.exports = __webpack_public_path__ + "img/terroir-redshift-3.0d0654dc.jpg";